import React, { memo } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Typography } from '@material-ui/core';

import CompaniesDropDawn from './CompaniesDropDawn';

import useStyles from '../styles';

const Companies = () => {
  const classes = useStyles();

  const validateFilters = (filters = []) => {
    return filters.map(filter => {
      const errors = {};
      if (!filter.companyIds?.toString()) {
        errors.companyIds = 'Please select a company or remove the item.';
      }
      return Object.keys(errors).length ? errors : undefined;
    });
  };

  return (
    <FieldArray name="crmCompanies" validate={validateFilters}>
      {({ fields }) => (
        <div className={classes.companyWrapper}>
          {fields.value?.length > 0 && (
            <>
              {fields.value.map((field, index) => {
                return (
                  <div className={classes.item} key={field.id}>
                    <Typography className={classes.name}>
                      {`${field.name}`}
                    </Typography>
                    <CompaniesDropDawn
                      data={field}
                      index={index}
                      removeFilter={fields.remove}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </FieldArray>
  );
};

export default memo(Companies);
